import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import CustomerOrderStatusBadge from '#/modules/crmMgmt/customerOrder/components/CustomerOrderStatusBadge';
import { formatDateOrDash } from '#/utils/date';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function formatCustomerLabel(customer) {
  if (!customer) {
    return '-';
  }
  const label = [customer.code, customer.name].filter(Boolean).join(' - ');
  return label || '-';
}

/**
 * CustomerOrderPickerDialog 用欄（無導航連結）。
 */
export function buildCustomerOrderPickerColumns() {
  return [
    {
      id: 'customerOrderNo',
      header: '客戶訂單號',
      accessorKey: 'customerOrderNo',
      accessorFn: (row) => displayDash(row.customerOrderNo),
      size: 140,
      enableColumnFilter: false,
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 110,
      enableColumnFilter: false,
      meta: {
        /** ListTable／Table：status 欄須 document 才走自訂 cell（Badge） */
        statusKind: 'document',
      },
      cell: ({ row }) => (
        row.original.status
          ? <CustomerOrderStatusBadge status={row.original.status} size="sm" />
          : '-'
      ),
    },
    {
      id: 'customer',
      header: '客戶',
      accessorFn: (row) => formatCustomerLabel(row.customer),
      size: 180,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ getValue }) => (
        <TruncatedTextWithTooltip text={getValue()} />
      ),
    },
    {
      id: 'customerOrderDate',
      header: '訂單日',
      accessorKey: 'customerOrderDate',
      accessorFn: (row) => formatDateOrDash(row.customerOrderDate),
      size: 120,
      enableColumnFilter: false,
    },
    {
      id: 'issueReason',
      header: '訂購事由',
      accessorKey: 'issueReason',
      accessorFn: (row) => displayDash(row.issueReason),
      size: 160,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ getValue }) => (
        <TruncatedTextWithTooltip text={getValue()} />
      ),
    },
    {
      id: 'remark',
      header: '備註',
      accessorKey: 'remark',
      accessorFn: (row) => displayDash(row.remark),
      size: 180,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ getValue }) => (
        <TruncatedTextWithTooltip text={getValue()} />
      ),
    },
  ];
}
